export class MeterTypeUtility {
  public static isSmartMeter(meterTypeCode: string): boolean {
    return meterTypeCode.indexOf('SMD') > -1;
  }
}
